import type { Hint } from "./types";
import { checkCandidate } from "./evaluator";

function generateAllCandidates(
  codeLength: number,
  digitRange: [number, number],
): number[][] {
  const digits: number[] = [];
  for (let d = digitRange[0]; d <= digitRange[1]; d++) {
    digits.push(d);
  }

  const totalSpace = Math.pow(digits.length, codeLength);
  const candidates: number[][] = [];

  for (let n = 0; n < totalSpace; n++) {
    const candidate: number[] = [];
    let remaining = n;
    for (let i = codeLength - 1; i >= 0; i--) {
      candidate[i] = digits[remaining % digits.length];
      remaining = Math.floor(remaining / digits.length);
    }
    candidates.push(candidate);
  }

  return candidates;
}

export function countRemainingSolutions(
  codeLength: number,
  hints: readonly Hint[],
  digitRange: [number, number] = [0, 9],
): number {
  const candidates = generateAllCandidates(codeLength, digitRange);
  let count = 0;
  for (const candidate of candidates) {
    if (checkCandidate(candidate, hints)) {
      count++;
    }
  }
  return count;
}

export function findAllSolutions(
  codeLength: number,
  hints: readonly Hint[],
  digitRange: [number, number] = [0, 9],
): number[][] {
  const candidates = generateAllCandidates(codeLength, digitRange);
  const solutions: number[][] = [];
  for (const candidate of candidates) {
    if (checkCandidate(candidate, hints)) {
      solutions.push(candidate);
    }
  }
  return solutions;
}
